import React from "react";

export const EscapeNarrative = ({ narrative }) => (
  <section
    data-testid="escape-narrative"
    className="mx-auto max-w-[1400px] px-6 pt-20 md:px-10 md:pt-24"
  >
    <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
      <div className="md:col-span-7">
        <p className="overline text-brand-inkSoft">About this escape</p>
        <h2 data-testid="narrative-beauty" className="font-display mt-3 text-3xl leading-tight md:text-4xl">
          {narrative.beauty}
        </h2>
        <p data-testid="narrative-why" className="mt-6 text-base text-brand-inkSoft md:text-lg">
          {narrative.whyAmazing}
        </p>

        <p className="overline mt-12 text-brand-inkSoft">What you can do</p>
        <ul data-testid="narrative-activities" className="mt-4 grid grid-cols-1 gap-2 md:grid-cols-2">
          {narrative.activities.map((a) => (
            <li key={a} className="flex items-start gap-2 text-brand-ink">
              <span className="mt-2 inline-block h-1.5 w-1.5 flex-shrink-0 rounded-full bg-brand-terracotta" />
              <span className="text-sm md:text-base">{a}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-5">
        <div className="sticky top-28 rounded-2xl border border-brand-line bg-white p-7">
          <p className="overline text-brand-inkSoft">Who is it for</p>
          <h3 className="font-display mt-2 text-2xl leading-tight">Group size & who travels best</h3>

          <div data-testid="narrative-solo" className="mt-6 rounded-xl bg-brand-bg2 p-5">
            <p className="overline text-brand-terracottaDeep">Solo travel</p>
            <p className="mt-2 text-sm text-brand-ink">{narrative.groupFit.solo}</p>
          </div>

          <div className="mt-4 space-y-3 text-sm">
            <div data-testid="narrative-couples">
              <span className="font-medium text-brand-ink">Couples · </span>
              <span className="text-brand-inkSoft">{narrative.groupFit.couples}</span>
            </div>
            <div data-testid="narrative-friends">
              <span className="font-medium text-brand-ink">Friends · </span>
              <span className="text-brand-inkSoft">{narrative.groupFit.friends}</span>
            </div>
            <div data-testid="narrative-family">
              <span className="font-medium text-brand-ink">Family · </span>
              <span className="text-brand-inkSoft">{narrative.groupFit.family}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default EscapeNarrative;
